import colors from "../../base/colors";
import typography from "../../base/typography";
import pxToRem from "../../functions/pxToRem";

const { text, primary, error } = colors;
const { size, fontWeightBold } = typography;

const inputLabel = {
  defaultProps: {
    shrink: true,
  },
  styleOverrides: {
    root: {
      position: "relative",
      transform: "none",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      pointerEvents: "auto",
      fontSize: pxToRem(14),
      fontWeight: fontWeightBold,
      lineHeight: 1.4,
      color: text.main,
      marginBottom: pxToRem(4),

      "&.Mui-focused": {
        color: primary.main,
      },

      "&.Mui-error": {
        color: error.main,
      },

      "&.MuiInputLabel-shrink": {
        transform: "none",
        fontSize: pxToRem(14),
        lineHeight: 1.4,
        maxWidth: "100%",
      },

      "& .MuiInputLabel-asterisk": {
        color: error.main,
      },
    },

    sizeSmall: {
      fontSize: pxToRem(14),
      lineHeight: 1.4,

      "&.MuiInputLabel-shrink": {
        fontSize: pxToRem(14),
        lineHeight: 1.4,
      },
    },

    outlined: {
      transform: "none",
      "&.MuiInputLabel-shrink": {
        transform: "none",
      },
    },
  },
};

export default inputLabel;
